// SPEC-13 · Boas-vindas. Shown only when there is no session: the photo,
// the logo, one line about PYF, and the two ways in.
//
// SPEC-31: the first screen with words, so the language is chosen here,
// before any account: « PT · FR · EN » at the top right of the photo.

import { useState } from "react";

import runnerPhoto from "../assets/p8-runner.jpg";
import { LanguageControl } from "../components/LanguageControl";
import { PyfLogo } from "../components/PyfLogo";
import { useCopy, useLanguageFade } from "../i18n/LanguageProvider";
import { Link, paths } from "../lib/router";

const button =
  "flex h-[var(--control-h)] w-full items-center justify-center rounded-pill text-body font-semibold no-underline " +
  "transition-colors duration-[var(--dur-micro)] ease-pyf";

export function Welcome() {
  // Without the photo the card keeps a cream block of the same size.
  const [photoFailed, setPhotoFailed] = useState(false);
  const text = useCopy().welcome;
  // After a change of language the words fade in; the photo and the control hold still.
  const fade = useLanguageFade();

  return (
    <main className="screen-enter flex min-h-dvh flex-col bg-cream">
      <div className="px-4 pt-4">
        <div className="relative h-[min(400px,48dvh)] overflow-hidden rounded-card-outer bg-cream-deep">
          {!photoFailed && (
            <img
              src={runnerPhoto}
              alt=""
              className="block h-full w-full object-cover"
              onError={() => {
                console.error("[welcome] the photo did not load; showing the cream block");
                setPhotoFailed(true);
              }}
            />
          )}
          <div className="absolute top-3 right-3">
            <LanguageControl label={text.language} onPhoto />
          </div>
        </div>
      </div>

      <div className={`${fade} flex flex-col gap-3 px-5 pt-7`}>
        <PyfLogo className="w-14 text-dark" />
        <h1 className="text-display leading-[var(--lh-display)] font-semibold tracking-[var(--ls-display)] text-pretty">
          {text.title}
        </h1>
        <p className="text-body leading-[var(--lh-body)] text-muted text-pretty">{text.lead}</p>
      </div>

      <div className={`${fade} mt-auto flex flex-col gap-2 px-5 pt-8 pb-9`}>
        <Link
          to={paths.signUp}
          className={`${button} bg-dark text-cream hover:bg-dark-hover hover:text-cream`}
        >
          {text.signUp}
        </Link>
        <Link to={paths.signIn} className={`${button} text-violet hover:text-violet-ink`}>
          {text.signIn}
        </Link>
      </div>
    </main>
  );
}
